import store from '../store/store';
import NavBarData from 'owa-service/lib/contract/NavBarData';

export default function getBposNavBarData(): NavBarData {
    return store.bposNavBarData;
}
